import { Component, ElementRef, OnInit, Input } from '@angular/core';
import * as d3 from 'd3';

@Component({
  selector: 'lfx-bubble-chart',
  templateUrl: './bubble-chart.component.html',
  styleUrls: ['./bubble-chart.component.scss'],
})
export class BubbleChartComponent implements OnInit {
  @Input() visualizationData: any;
  @Input() options: any;
  haveLegend = false;
  legendColors: any = [];
  legendList = {
    left: [],
    right: [],
  };

  private htmlElement: HTMLElement;
  private host: d3.Selection<any, any, any, any>;

  constructor(private elementRef: ElementRef) {
    this.htmlElement = this.elementRef.nativeElement;
    this.host = d3.select(this.htmlElement);
  }

  ngOnInit() {
    this.haveLegend = this.options.stackDepthLegend;
    this.createBubbleChart(this.visualizationData, this.options);

    if (this.haveLegend) {
      this.generateLegend();
    }
  }

  private generateLegend() {
    this.legendColors = this.options.colors
      ? [...this.options.colors, ...d3.schemeCategory10]
      : d3.schemeCategory10;
    const legends = [];

    // tslint:disable-next-line: forin
    for (const key in this.visualizationData.children[0].children) {
      if (
        {}.hasOwnProperty.call(this.visualizationData.children[0].children, key) // Check https://eslint.org/docs/rules/guard-for-in
      ) {
        legends.push({
          color: this.legendColors[key],
          name: this.visualizationData.children[0].children[key].Name,
        });
      }
    }

    const mid = Math.ceil(legends.length / 2);

    this.legendList = {
      left: legends.slice(0, mid),
      right: legends.slice(mid),
    };
  }

  private createBubbleChart(dataset: any, options?: any) {
    const height = 300;
    const width = 400;
    const color = d3.scaleOrdinal(
      options.colors
        ? [...options.colors, ...d3.schemeCategory10]
        : d3.schemeCategory10
    );
    const bubble = d3.pack().size([width, height]).padding(1.5);

    const svg = this.host
      .select('#bubble-chart')
      .append('svg')
      .attr('width', width)
      .attr('height', height)
      .attr('class', 'bubble');

    const nodes = d3.hierarchy(dataset).sum((d: any) => d.Count);

    const node = svg
      .selectAll('.node')
      .data(bubble(nodes).descendants())
      .enter()
      .filter(d => !d.children)
      .append('g')
      .attr('class', 'node')
      .attr('transform', d => 'translate(' + d.x + ',' + d.y + ')')
      .style('fill', (d, i: any) => color(i));

    node.append('title').text((d: any) => d.Name + ': ' + d.Count);

    node
      .append('circle')
      .attr('x', d => d.x)
      .attr('y', d => d.y)
      .attr('r', d => d.r)
      .style('fill', (d, i: any) => color(i));

    if (options.showText) {
      node
        .append('text')
        .attr('dy', '.2em')
        .style('text-anchor', 'middle')
        .text((d: any) => d.data.Name.substring(0, d.r / 3))
        .attr('font-family', 'Source Sans Pro, sans-serif')
        .attr('font-size', d => d.r / 5)
        .attr('fill', 'white');
    }

    if (options.showCount) {
      node
        .append('text')
        .style('text-anchor', 'middle')
        .text((d: any) => d.data.Count)
        .attr('font-size', '16px')
        .attr('font-weight', 'bold')
        .attr('fill', 'white');
    }
  }
}
